<template>
  <div>
    <div class="h2">
      Expression de vos besoins et de vos exigences
    </div>

    <!-- RIA -->
    <input-checkbox-simple
      label="Êtes-vous déjà couvert par un contrat d’assurance santé individuelle ?"
      slug="couvertureSante"
      :model="couvertureSante"
      :true-value="'1'"
      :false-value="'0'"
      :v$="v$"
      @change-value="$emit('update:couvertureSante', $event)"
    />

    <div
      v-show="couvertureSante === '1'"
      data-cy="ria"
    >
      <span>Votre contrat actuel a-t-il plus de 12 mois d'ancienneté ?</span>
      <input-radio
        label=""
        slug="ancienContrat12MoisAnciennete"
        :model="ancienContrat12MoisAnciennete"
        :options="[
          {'label': 'Oui', 'value': '1'},
          {'label': 'Non', 'value': '0'}
        ]"
        :v$="v$"
        @input="$emit('update:ancienContrat12MoisAnciennete', $event.target.value)"
      />

      <div v-show="ancienContrat12MoisAnciennete === '0'">
        <span>Votre contrat actuel a-t-il plus de 6 mois d'ancienneté ?</span>
        <input-radio
          label=""
          slug="ancienContrat6MoisAnciennete"
          :model="ancienContrat6MoisAnciennete"
          :options="[
            {'label': 'Oui', 'value': '1'},
            {'label': 'Non', 'value': '0'}
          ]"
          :v$="v$"
          @input="$emit('update:ancienContrat6MoisAnciennete', $event.target.value)"
        />
      </div>

      <input-text-date-picker
        label="Date d’effet de votre ancien contrat d'assurance santé individuelle *"
        slug="dateEffetAncienContrat"
        :model="dateEffetAncienContrat"
        from-date="01/01/2000"
        :to-date="yesterdayDate"
        :v$="v$"
        @updateDate="$emit('update:dateEffetAncienContrat', $event)"
      />
    </div>

    <!-- Date d'effet du contrat -->
    <input-text-date-picker
      label="Date d'effet souhaitée pour votre contrat d’assurance santé individuelle Swiss Life *"
      slug="dateEffet"
      :model="dateEffet"
      :from-date="dateEffetFrom"
      :to-date="dateEffetTo"
      :v$="v$"
      @updateDate="$emit('update:dateEffet', $event)"
    />

    <div class="h3">
      Vos besoins
    </div>

    <!-- Types de garanties -->
    <input-radio
      label=""
      slug="typeGarantie"
      :model="typeGarantie"
      :options="[
        {'label': 'Je recherche des garanties complètes', 'value': '1'},
        {'label': 'Risque d\'hospitalisation uniquement', 'value': '2'},
        {'label': 'Je suis titulaire d\'une Complémentaire Santé Solidaire', 'value': '3'}
      ]"
      :v$="v$"
      @input="$emit('update:typeGarantie', $event.target.value)"
    />

    <div v-if="displayObstetriqueOuOrthodontie === '1'">
      <div class="h3">
        Vos exigences
      </div>

      <input-checkbox-simple
        label="Je souhaite une couverture en obstétrique"
        slug="besoinObstetrique"
        :model="besoinObstetrique"
        :true-value="'1'"
        :false-value="'0'"
        :v$="v$"
        @change-value="$emit('update:besoinObstetrique', $event)"
      />

      <input-checkbox-simple
        label="Je souhaite une couverture en orthodontie"
        slug="besoinOrthodontie"
        :model="besoinOrthodontie"
        :true-value="'1'"
        :false-value="'0'"
        :v$="v$"
        @change-value="$emit('update:besoinOrthodontie', $event)"
      />
    </div>

    <!-- Montant niveau de garantie important -->
    <input-radio
      label="Est-ce que le montant de la cotisation est un élément plus important que le niveau de garantie ?"
      slug="montantGarantieImportant"
      :model="montantGarantieImportant"
      :options="[{'label': 'Oui', 'value': '1'}, {'label': 'Non', 'value': '0'}]"
      :v$="v$"
      @input="$emit('update:montantGarantieImportant', $event.target.value)"
    />

    <div v-if="montantGarantieImportant === '1'" class="mb-4">
      <input-text
        label="Quel serait votre budget mensuel ? (Saisissez un montant par dizaine, ex: 10, 20, 30...)"
        slug="budgetMensuel"
        :model="budgetMensuel"
        :v$="v$"
        type="number"
        step="10"
        min="0"
        max="990"
        @input="handleBudgetInput"
      />
    </div>

    <div class="h3">
      Vos exigences en matière de couverture (ajustez les curseurs en fonction de vos exigences)
    </div>

    <!-- Disclaimer -->
    <div v-if="montantGarantieImportant === '1'" class="disclaimer mt-2 mb-4">
      Le niveau de garantie souhaité ne sera pas forcément respecté compte tenu du budget mensuel renseigné.
    </div>

    <input-slider
      label="Hospitalisation"
      slug="niveau_hospi"
      :model="niveauHospi"
      :v$="v$"
      min="0"
      max="100"
      step="10"
      :description-map="sliderDescriptionGeneralMap"
      @input="$emit('update:niveauHospi', $event.target.value)"
    />

    <input-slider
      label="Dentaire"
      slug="niveau_dentaire"
      :model="niveauDentaire"
      :v$="v$"
      min="0"
      max="100"
      step="10"
      :description-map="sliderDescriptionGeneralMap"
      @input="$emit('update:niveauDentaire', $event.target.value)"
    />

    <input-slider
      label="Optique"
      slug="niveau_optique"
      :model="niveauOptique"
      :v$="v$"
      min="0"
      max="100"
      step="10"
      :description-map="sliderDescriptionGeneralMap"
      @input="$emit('update:niveauOptique', $event.target.value)"
    />

    <input-slider
      label="Honoraires médicaux et Pharmacie"
      slug="niveau_honoraire"
      :model="niveauHonoraire"
      :v$="v$"
      min="0"
      max="100"
      step="10"
      :description-map="sliderDescriptionGeneralMap"
      @input="$emit('update:niveauHonoraire', $event.target.value)"
    />

    <input-slider
      label="Prévention"
      slug="niveau_prevention"
      :model="niveauPrevention"
      :v$="v$"
      min="0"
      max="100"
      step="10"
      :description-map="sliderDescriptionPreventionMap"
      @input="$emit('update:niveauPrevention', $event.target.value)"
    />
  </div>
</template>

<script>

import InputCheckboxSimple from "src/modules/shared/components/Form/InputCheckboxSimple";
import InputRadio from "src/modules/shared/components/Form/InputRadio";
import InputText from "src/modules/shared/components/Form/InputText";
import {computed} from "vue";
import {serverError, required, requiredIf, dateLessThan6MonthsFromToday } from "src/modules/shared/validators/validators";
import useVuelidate from "@vuelidate/core";
import InputSlider from "src/modules/shared/components/Form/InputSlider";
import InputTextDatePicker from "src/modules/shared/components/Form/InputTextDatePicker";
import dayjs from "dayjs";

export default {
  name: "NeedsInformationForm",
  components: {
    InputCheckboxSimple,
    InputRadio,
    InputSlider,
    InputText,
    InputTextDatePicker
  },
  props: {
    serverErrors: {
      type: Array,
      required: true
    },
    couvertureSante: {
      type: String,
      default: ''
    },
    dateEffet: {
      type: String,
      default: ''
    },
    typeGarantie: {
      type: String,
      default: ''
    },
    besoinObstetrique: {
      type: String,
      default: ''
    },
    besoinOrthodontie: {
      type: String,
      default: ''
    },
    displayObstetriqueOuOrthodontie: {
      type: String,
      default: ''
    },
    niveauHospi: {
      type: String,
      default: ''
    },
    niveauDentaire: {
      type: String,
      default: ''
    },
    niveauOptique: {
      type: String,
      default: ''
    },
    niveauHonoraire: {
      type: String,
      default: ''
    },
    niveauPrevention: {
      type: String,
      default: ''
    },
    ancienContrat12MoisAnciennete: {
      type: String,
      default: ''
    },
    ancienContrat6MoisAnciennete: {
      type: String,
      default: ''
    },
    dateEffetAncienContrat: {
      type: String,
      default: ''
    },
    dateEffetFrom: {
      type: String,
      default: ''
    },
    dateEffetTo: {
      type: String,
      default: ''
    },
    montantGarantieImportant: {
      type: String,
      default: ''
    },
    budgetMensuel: {
      type: String,
      default: ''
    }
  },
  emits: [
    'update:couvertureSante',
    'update:dateEffet',
    'update:typeGarantie',
    'update:niveauHospi',
    'update:niveauDentaire',
    'update:niveauOptique',
    'update:niveauHonoraire',
    'update:niveauPrevention',
    'update:besoinObstetrique',
    'update:besoinOrthodontie',
    'update:ancienContrat12MoisAnciennete',
    'update:ancienContrat6MoisAnciennete',
    'update:dateEffetAncienContrat',
    'update:montantGarantieImportant',
    'update:budgetMensuel'
  ],
  setup (props, context) {
    const validations = computed(() => ({
      couvertureSante: {
        required,
        serverError: serverError(props, 'couvertureSante')
      },
      dateEffet: {
        required,
        dateLessThan6MonthsFromToday,
        serverError: serverError(props, 'dateEffet')
      },
      typeGarantie: {
        required,
        serverError: serverError(props, 'typeGarantie')
      },
      besoinObstetrique: {
        requiredIf: requiredIf(props.displayObstetriqueOuOrthodontie),
        serverError: serverError(props, 'besoinObstetrique')
      },
      besoinOrthodontie: {
        requiredIf: requiredIf(props.displayObstetriqueOuOrthodontie),
        serverError: serverError(props, 'besoinOrthodontie')
      },
      niveauHospi: {
        required,
        serverError: serverError(props, 'niveau_hospi')
      },
      niveauDentaire: {
        required,
        serverError: serverError(props, 'niveau_dentaire')
      },
      niveauOptique: {
        required,
        serverError: serverError(props, 'niveau_optique')
      },
      niveauHonoraire: {
        required,
        serverError: serverError(props, 'niveau_honoraire')
      },
      niveauPrevention: {
        required,
        serverError: serverError(props, 'niveau_prevention')
      },
      ancienContrat12MoisAnciennete: {
        serverError: serverError(props, 'ancienContrat12MoisAnciennete')
      },
      ancienContrat6MoisAnciennete: {
        serverError: serverError(props, 'ancienContrat6MoisAnciennete')
      },
      dateEffetAncienContrat: {
        serverError: serverError(props, 'dateEffetAncienContrat')
      },
      montantGarantieImportant: {
        required,
        serverError: serverError(props, 'montantGarantieImportant')
      },
      budgetMensuel: {
        requiredIf: requiredIf(props.montantGarantieImportant === '1'),
        minValue: {
          $validator: (value) => {
            if (props.montantGarantieImportant === '1') {
              return parseInt(value) > 0;
            }
            return true;
          },
          $message: 'Le budget mensuel doit être supérieur à 0'
        },
        serverError: serverError(props, 'budgetMensuel')
      }
    }))

    const v$ = useVuelidate(validations, props)

    const sliderDescriptionGeneralMap = {
      0: "Pas important",
      10: "Peu important",
      20: "Peu important",
      30: "Peu important",
      40: "Peu important",
      50: "Peu important",
      60: "Important",
      70: "Important",
      80: "Important",
      90: "Très important",
      100: "Très important",
    }

    const sliderDescriptionPreventionMap = {
      0: "Faible",
      10: "Moyen",
      20: "Moyen",
      30: "Moyen",
      40: "Moyen",
      50: "Important",
      60: "Important",
      70: "Important",
      80: "Important",
      90: "Très important",
      100: "Très important",
    }

    const handleBudgetInput = (event) => {
      // Récupère la valeur et ne garde que les chiffres
      let value = event.target.value.replace(/[^\d]/g, '')
      let numValue = parseInt(value || 0)
      
      // Si la valeur est supérieure à 990, on utilise la valeur précédente
      if (numValue > 990) {
        event.target.value = props.budgetMensuel
        return
      }

      // Émet d'abord la valeur non arrondie
      context.emit('update:budgetMensuel', value)
      
      // Attend 800ms après la dernière frappe pour arrondir
      clearTimeout(window.budgetTimeout)
      window.budgetTimeout = setTimeout(() => {
        // Arrondit à la dizaine la plus proche
        value = Math.round(numValue / 10) * 10
        // Limite entre 0 et 990
        value = Math.min(Math.max(value, 0), 990)
        // Émet la valeur arrondie
        context.emit('update:budgetMensuel', value.toString())
      }, 800)
    }

    return { v$, sliderDescriptionGeneralMap, sliderDescriptionPreventionMap, handleBudgetInput }
  },
  data () {
    return {
    }
  },
  computed: {
    yesterdayDate() {
      return dayjs().subtract(1, 'days').format('DD/MM/YYYY')
    }
  },
  watch: {
    serverErrors () {
      this.v$.$reset()
      this.v$.$touch()
    }
  },
  mounted() {

  }
}
</script>

<style scoped>
.disclaimer {
  color: #666;
  font-style: italic;
  font-size: 0.9em;
}
</style>
